export class SecurityQuestion {
    Id: number;
    Name: string;
    Answers: Array<Question>;

    constructor(){
        this.Answers = new Array<Question> ()
    }
}

export class Question{
    Id: number;
    QuestionId: number;
    Name: string;
    Coment: string;
    Yes: boolean;
    No: boolean;
    _hasError: boolean;

    constructor(){
        this._hasError = false;
        this.Coment = ""
    }
}